import classNames from 'classnames';

import CompanySettingsDomains from './_company_settings_domains';
import CompanySettingsTracking from './_company_settings_tracking';
import CompanySettingsBoardCurators from './_company_settings_board_curators';
import CompanySettingsDigest from './_company_settings_digest';
import CompanySettingsAlerts from './_company_settings_alerts';
import CompanySettingsMonitors from './_company_settings_monitors';
import CompanySettingsTags from './_company_settings_tags';

import {userIsAdmin, userCanCurate} from '../modules/roles_utils';
import {withRouter} from 'react-router-dom';
import Icon from './_icon';

class CompanySettings extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired,
    appData: PropTypes.object.isRequired
  };

  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  };

  static defaultProps = {
    match: {},
    history: null
  };

  componentDidMount() {
    // DEBUG
    console.log('CompanySettings.componentDidMount: props: %o', this.props);
  }

  getCurrentPageSlug = () => {
    const {match: {params: {pageSlug = ''} = {}}} = this.props;

    return pageSlug.toLowerCase();
  };

  getCurrentPageSection = () => {
    const {match: {params: {pageSection = ''} = {}}} = this.props;

    return pageSection.toLowerCase();
  };

  followNavItem = (slug = '') => this.props.history.push(`/settings/${slug}`);

  renderNavItem = slug => {
    const {utils: {isDigestMultiplesEnabled}} = this.context;

    const currentPageSlug = this.getCurrentPageSlug();
    const navClass = classNames('settings-nav_link', {
      'settings-nav_link--active': currentPageSlug === slug
    });
    const navLabels = {
      'profile-curators': 'Curator Assignments',
      digest: 'Intel Digest' + (isDigestMultiplesEnabled() ? 's' : ''),
      alerts: 'Alerts Settings',
      monitors: 'Monitors Settings',
      tags: 'Tags'
    };
    const handleClick = () => (slug ? this.followNavItem(slug) : '');

    return (
      <div
        key={`settingsNav-${slug}`}
        className={navClass}
        onClick={handleClick}>
        {navLabels[slug]}
      </div>
    );
  };

  render() {
    const {utils, appData: {helpDocsHost, helpDocsArticles = {}}} = this.context;
    const {usageDataExport} = helpDocsArticles;
    const {user, userIsStaff} = utils;
    const currentPageSlug = this.getCurrentPageSlug();
    const currentPageSection = this.getCurrentPageSection();
    const isCompanyAdmin = userIsAdmin({user});
    const isCurator = userCanCurate({user});
    const isStaff = userIsStaff();
    const isAdminOrStaff = isCompanyAdmin || isStaff;
    const isAdminOrStaffOrCurator = isAdminOrStaff || isCurator;
    const uiNavAdmin = (
      <div className="u-pt-l">
        <div className="settings-section-heading u-mb-s">Administration</div>
        <div className="settings-nav">
          {isAdminOrStaff ? [this.renderNavItem('profile-curators'), this.renderNavItem('digest')] : null}
          {isAdminOrStaffOrCurator ? this.renderNavItem('alerts') : null}
          {isAdminOrStaffOrCurator ? this.renderNavItem('monitors') : null}
          {isAdminOrStaff ? this.renderNavItem('tags') : null}
        </div>
      </div>
    );
    let uiPage;

    if(!currentPageSlug) {
      uiPage = <CompanySettingsDomains />;
    }
    else if(currentPageSlug === 'tracking') {
      uiPage = <CompanySettingsTracking />;
    }
    else if(currentPageSlug === 'alerts') {
      uiPage = <CompanySettingsAlerts />;
    }
    else if(currentPageSlug === 'monitors') {
      uiPage = <CompanySettingsMonitors />;
    }
    else if(isAdminOrStaff && currentPageSlug === 'tags') {
      uiPage = <CompanySettingsTags />;
    }
    else if(isCompanyAdmin || isStaff) {
      if(currentPageSlug === 'profile-curators') {
        uiPage = (
          <CompanySettingsBoardCurators section={currentPageSection} />
        );
      }
      else if(currentPageSlug === 'digest') {
        uiPage = <CompanySettingsDigest />;
      }
    }
    else {
      // requested page slug not found
      this.followNavItem();
    }

    return (
      <div className="layout-settings">
        <div className="layout-settings_sidebar">
          <div className="settings-section-heading u-mb-s">Company Settings</div>
          <div className="settings-nav">
            <div
              className={'settings-nav_link ' + (!currentPageSlug ? 'settings-nav_link--active' : '')}
              onClick={() => this.followNavItem()}>
              Login Domains
            </div>
            <div
              className={'settings-nav_link ' + (currentPageSlug === 'tracking' ? 'settings-nav_link--active' : '')}
              onClick={() => this.followNavItem('tracking')}>
              Tracking
            </div>
          </div>
          {uiNavAdmin}
        </div>
        <div className="layout-settings_content">
          {currentPageSlug === 'tracking' ? <div className="layout-settings-warning">
            <Icon width="24" height="24" icon="alert" />
            <span>This data won't be available after June 15, 2023. Migrate to Usage Data Export API.&nbsp;<a href={`https://${helpDocsHost}/${usageDataExport}`}>Learn More</a></span>
          </div> : null}
          <div className="layout-settings-panel">
            <div className="layout-settings-panel_inset">
              {uiPage}
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(CompanySettings);
